import { render, staticRenderFns } from "./articleWatch.vue?vue&type=template&id=7be4eeec&scoped=true"
import script from "./articleWatch.vue?vue&type=script&lang=js"
export * from "./articleWatch.vue?vue&type=script&lang=js"
import style0 from "./articleWatch.vue?vue&type=style&index=0&id=7be4eeec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be4eeec",
  null
  
)

export default component.exports